/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MinusIcon20Solid = forwardRef('MinusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M1 10.5A1.5 1.5 0 0 1 2.5 9h14a1.5 1.5 0 0 1 0 3h-14A1.5 1.5 0 0 1 1 10.5Z" })));
});
